module.exports = __webpack_public_path__ + "static/media/CallCenter.e7551b38.gif";